export default {"src":"/_next/static/image/public/images/flags/flag_965.a699e714f976205261434320028b2832.svg","height":16,"width":24};